import { createFileRoute, redirect } from '@tanstack/react-router';
import AdminPage from '../pages/AdminPage';
import { getProfileSync } from '../lib/getProfileSync';

export const Route = createFileRoute('/admin')({
  beforeLoad: () => {
    const profile = getProfileSync();
    if (!profile || profile.status !== 'active') throw redirect({ to: '/' });
    if (profile.role !== 'Admin')                throw redirect({ to: '/' });
  },
  component: AdminPage,
});
